import React, { useState } from 'react';
import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { LoadingButton } from '@mui/lab';
import { firestore } from '../../../../contexts/FirebaseContext';
import useAuth from '../../../../hooks/useAuth';
import { getUserNip } from '../../../../utils/adminTools/getUserNip';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';

function DialogCancelarEnvio({ data, dataAdmin, dialogProp }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Box>
      <Button
        variant={dialogProp ? dialogProp?.variant || 'contained' : 'contained'}
        size={dialogProp ? dialogProp?.size : 'medium'}
        color={dialogProp ? dialogProp?.color : 'error'}
        onClick={() => setOpenDialog(true)}
      >
        Solicitar cancelacion
      </Button>
      <DialogCancerlar open={openDialog} onClose={setOpenDialog} data={data} adminId={dataAdmin?.id} />
    </Box>
  );
}

export default DialogCancelarEnvio;

function DialogCancerlar({ open, onClose, data, adminId }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const handleClose = () => {
    onClose(false);
  };

  const cancelEnvio = async (dataForm) => {
    setLoading(true);
    let userNip;
    try {
      userNip = await getUserNip(adminId);
    } catch (error) {
      console.log(error);
      setLoading(false);
      enqueueSnackbar('Se ha producido un error al obtener el nip', { variant: 'error' });
    }

    if (userNip === dataForm.nip) {
      await firestore.collection('cotizaciones').doc(data?.id).update({ state: 'PENDIENTE-CANCELACION' });

      reset();
      enqueueSnackbar('La cancelacion esta pendiente', { variant: 'success' });
      setLoading(false);
      handleClose();
    } else {
      setLoading(false);
      enqueueSnackbar('Ingrese un NIP correcto', { variant: 'error' });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">¿Está seguro que desea cancelar este envio?</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(cancelEnvio)}>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
            {errors.message && (
              <Typography color="error" fontSize="13px">
                Ingrese un mensaje
              </Typography>
            )}
          </Box>
          <LoadingButton loading={loading} fullWidth variant="contained" type="submit">
            Cancelar envio
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
